var map = {
	"./Embassy.png": 7013,
	"./adani.png": 2644,
	"./adaniTransparent.png": 8784,
	"./birla.png": 6690,
	"./brigade.png": 3891,
	"./cbre.png": 8339,
	"./century.png": 6644,
	"./client2.png": 4777,
	"./dlf.png": 33,
	"./elan.png": 7076,
	"./eldeco.png": 965,
	"./emaar.png": 4558,
	"./experion.png": 6571,
	"./gleeds.png": 4698,
	"./godrej.png": 3946,
	"./godrejproperties.png": 8289,
	"./jll.png": 5439,
	"./lodha.png": 4396,
	"./lodhaTransparent.png": 9284,
	"./lt.png": 5609,
	"./maia.png": 5696,
	"./maxEstates.png": 5036,
	"./piramalRealty.png": 9554,
	"./piramalRealtyTransparent.png": 8310,
	"./royalorchid.png": 1812,
	"./saifee.png": 2663,
	"./savills.png": 7807,
	"./thehouseofabhinandan.png": 577,
	"./tvs.png": 1492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 891;